export const traceRegistry = new WeakMap<XMLHttpRequest, string>();
